import { ajaxAuth } from "@tm/utils"
import { PagedResponse } from "@tm/models"
import { WebserviceUrl } from "../../webserviceUrls"
import { ShowCustomRepairTimeListsRequest, ShowCustomRepairTimeListsResponse } from "./models"

export async function showCustomRepairTimeLists(body: ShowCustomRepairTimeListsRequest): Promise<PagedResponse<ShowCustomRepairTimeListsResponse>> {
    const url = `${WebserviceUrl.BasketCustomRepairTimes}/ShowCustomRepairTimeLists`
    try {
        const response = await ajaxAuth<ShowCustomRepairTimeListsResponse>({ url, body }, undefined, undefined, true)
        return {
            data: response ?? {
                customRepairTimeLists: [],
                unlistedRepairTimesCount: 0,
                pageIndex: body.pageIndex,
                pageSize: body.pageSize,
            },
            pageIndex: body.pageIndex,
            endOfList: (response?.customRepairTimeLists?.length ?? 0) < body.pageSize,
        }
    } catch {
        return {
            data: {
                customRepairTimeLists: [],
                unlistedRepairTimesCount: 0,
                pageIndex: body.pageIndex,
                pageSize: body.pageSize,
            },
            pageIndex: 0,
            endOfList: true,
        }
    }
}
